import {BaseModule} from './base.module';

export class FeedbackModule extends BaseModule {
    initialize() {
        (function () {
            var exp = document.createElement('script');
            exp.type = 'text/javascript';
            exp.async = true;
            exp.onload = function () {
                window.expoints = lightningjs.require('expoints', 'https://jaarbeurs1.expoints.nl/m/Scripts/dist/expoints-external.min.js');
                expoints('start', '36063c52-7906-4112-938e-b4a1200fc72b', {
                    instanceUrl: 'https://jaarbeurs1.expoints.nl',
                    isTest: false
                }, loadSecondConfiguration);

                function loadSecondConfiguration() {
                    expoints.registerConfig('f3114181-d0f6-48c2-8a67-a57624696d9b', {
                        instanceUrl: 'https://jaarbeurs2.expoints.nl',
                        isTest: false
                    });
                }
            };
            exp.src = 'https://jaarbeurs1.expoints.nl/m/Scripts/dist/expoints-external-loader.min.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(exp, s);
        })();

    }
}